module.exports = __webpack_public_path__ + "fddb5f749e8d236b4127a9b33691cc1d.pdf";